import Content from "../../help/warehouse-list.mdx";

export function WarehouseListHelpPage() {
  return <Content />;
}
